// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1cmTD","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__lM4AS"};